import React from 'react'
import './Score.css'

const Score = (props) => {
    return (
        <div>
           <h2 id="score">Score: {props.score}</h2>
        </div>
    )
}

export default Score
